import { Link } from 'react-router-dom';

export default function Popup({ timerIsFinished, time, errorCount, isFillTheGap, onCorrection }) {   
    if (!timerIsFinished) return null;
    return (
        <div id="endGamePopup" className={`popup ${timerIsFinished ? "open" : ""}`}>
            <div className="popup-content">
                <div className="popup-text">
                    {isFillTheGap ? (
                        <>
                            {errorCount === 0 ? (
                                <h5>Félicitations</h5>
                                ) :  (
                                <h5>Dommage</h5>
                            )}
                            {time ? (
                                <p>Vous avez terminé le jeu en <span className="final-time">{time}</span></p>
                                ) : (
                                <p>Calcul du temps...</p>
                            )}
                            {errorCount === 0 ? (
                                <p>Vous n'avez pas fait d'erreur</p>
                                ) : errorCount === 1 ? (
                                <p>Vous avez fait {errorCount} erreur. Souhaitez-vous la corriger ?</p>
                                ) : (
                                <p>Vous avez fait {errorCount} erreurs. Souhaitez-vous les corriger ?</p>
                            )}
                        </>
                    ) : (
                        <>
                            {errorCount <= 5 ? (
                                <h5>Félicitations</h5>
                                ) : errorCount <= 10 ? (
                                <h5>Bien tenté</h5>
                                ) : (
                                <h5>Dommage</h5>
                            )}
                            {time ? (
                                <p>Vous avez terminé le jeu en <span className="final-time">{time}</span></p>
                                ) : (
                                <p>Calcul du temps...</p>
                            )}
                            {errorCount === 0 ? (
                                <p>Vous n'avez pas fait d'erreur</p>
                                ) : errorCount === 1 ? (
                                <p>Vous avez fait {errorCount} erreur</p>
                                ) : (
                                <p>Vous avez fait {errorCount} erreurs</p>
                            )}
                        </>
                    )}
                </div>
                <div className="popup-btn-choice">
                    {isFillTheGap ? (
                        <>
                            {errorCount === 0 ? (
                                <button className="play-again btn-full" onClick={() => window.location.reload()}>Rejouer</button>
                                ) :  (
                                <button className="correct btn-full" onClick={onCorrection}>Corriger</button>
                            )}
                            <Link to="/themeSelector">
                                <button className="leave btn-empty">Quitter</button>
                            </Link>
                        </>
                    ) : (
                        <>
                            <button className="play-again btn-full" onClick={() => window.location.reload()}>Rejouer</button>
                            <Link to="/themeSelector">
                                <button className="leave btn-empty">Quitter</button>
                            </Link>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}